import type { mediaBulk as mediaBulkEn } from "../en/mediaBulk";

// Výběr, hromadné akce a alba na stránce Média.
export const mediaBulk: typeof mediaBulkEn = {
  selected_one: "{{count}} vybraná",
  selected_few: "{{count}} vybrané",
  selected_other: "{{count}} vybraných",
  clearSelection: "Zrušit výběr",
  actions: {
    addCountries: "Přiřadit zemi",
    removeCountries: "Odebrat zemi",
    setSource: "Nastavit zdroj",
    star: "Označit ★",
    unstar: "Zrušit ★",
    album: "Přidat do alba",
    move: "Přesunout do druhu",
    trash: "Smazat do koše",
    restore: "Obnovit",
  },
  actionTitles: {
    addCountries: "Přiřadit vybraným fotkám jednu nebo více zemí",
    removeCountries: "Odebrat vybraným fotkám jednu nebo více zemí",
    setSource: "Nastavit všem vybraným fotkám stejný zdroj",
    star: "Označit vybrané fotky jako dobré (★)",
    unstar: "Zrušit u vybraných fotek označení dobrá fotka (★)",
    album: "Přidat vybrané fotky do alba",
    move: "Přesunout vybrané fotky do jiného druhu",
    trash: "Přesunout vybrané fotky do koše",
    restore: "Obnovit vybrané fotky z koše",
  },
  countries: {
    addTitle_one: "Přiřadit zemi {{count}} fotce",
    addTitle_few: "Přiřadit zemi {{count}} fotkám",
    addTitle_other: "Přiřadit zemi {{count}} fotkám",
    removeTitle_one: "Odebrat zemi {{count}} fotce",
    removeTitle_few: "Odebrat zemi {{count}} fotkám",
    removeTitle_other: "Odebrat zemi {{count}} fotkám",
    label: "Země",
    save: "Uložit",
  },
  source: {
    title_one: "Zdroj {{count}} fotky",
    title_few: "Zdroj {{count}} fotek",
    title_other: "Zdroj {{count}} fotek",
    label: "Zdroj",
    hint: "Prázdné pole zdroj u vybraných fotek smaže.",
    save: "Uložit",
  },
  confirmDelete: {
    title_one: "Smazat {{count}} fotku do koše?",
    title_few: "Smazat {{count}} fotky do koše?",
    title_other: "Smazat {{count}} fotek do koše?",
    used_one: "{{count}} z {{total}} vybraných fotek je použitá na webu.",
    used_few: "{{count}} z {{total}} vybraných fotek jsou použité na webu.",
    used_other: "{{count}} z {{total}} vybraných fotek je použitých na webu.",
    noneUsed: "Žádná z vybraných fotek není použitá na webu.",
    confirm: "Smazat do koše",
  },
  restore: {
    twinsSkipped_one: "{{count}} fotka přeskočena: v knihovně už je živá fotka se stejným obsahem.",
    twinsSkipped_few:
      "{{count}} fotky přeskočeny: v knihovně už jsou živé fotky se stejným obsahem.",
    twinsSkipped_other:
      "{{count}} fotek přeskočeno: v knihovně už jsou živé fotky se stejným obsahem.",
    failed_one: "{{count}} fotku se nepodařilo obnovit, zůstává vybraná.",
    failed_few: "{{count}} fotky se nepodařilo obnovit, zůstávají vybrané.",
    failed_other: "{{count}} fotek se nepodařilo obnovit, zůstávají vybrané.",
  },
  album: {
    createTitle: "Nové album",
    createChildTitle: "Nové podalbum v albu {{parent}}",
    renameTitle: "Přejmenovat album",
    nameLabel: "Název alba",
    nameRequired: "Zadejte název alba.",
    save: "Uložit",
  },
};
